var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "loader",
    { attrs: { "is-loading": _vm.isLoadingAttributesObjRef } },
    _vm._l(_vm.attributeKeys, function(attribute) {
      return _c("div", { key: attribute }, [
        !_vm.attributesObjRef[attribute].autocomplete
          ? _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.generateMessage(
                          `${_vm.i18nPath || _vm.namespace}.fields.${attribute}`
                        )
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _vm.attributesObjRef[attribute].values.length > 2
                  ? _c("v-checkbox", {
                      staticClass: "ma-0 pa-0",
                      attrs: {
                        dense: "",
                        "input-value": _vm.isAttributeAllChecked(attribute),
                        "hide-details": ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.toggleAttribute(attribute)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.attributesObjRef[attribute].autocomplete
          ? _c(
              "div",
              { staticClass: "mt-4" },
              [
                _c("filter-autocomplete", {
                  attrs: {
                    i18nPath: _vm.i18nPath,
                    namespace: _vm.namespace,
                    attribute: attribute,
                    "id-field": "id",
                    "name-field": "name",
                    labelField: _vm.generateMessage(
                      `${_vm.i18nPath || _vm.namespace}.fields.${attribute}`
                    ),
                    outlined: "",
                    "shortname-field": "shortname"
                  }
                })
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "d-flex flex-wrap" },
              _vm._l(_vm.attributesObjRef[attribute].values, function(value) {
                return _c("div", { key: value.id }, [
                  _c(
                    "div",
                    { staticClass: "my-1 d-inline-flex align-top" },
                    [
                      _c("v-checkbox", {
                        staticClass: "ma-0 pa-0",
                        attrs: {
                          "hide-details": "",
                          dense: "",
                          "input-value": _vm.isValueChecked(attribute, value.id)
                        },
                        on: {
                          change: function($event) {
                            return _vm.handleAttributeValueChange(
                              $event,
                              attribute,
                              value.id
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ma-0 pa-0 pr-7" },
                        [
                          _vm.itemsHasAttributeValueNumber(attribute, value.id)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-0 mr-1",
                                  attrs: { small: "" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.itemsHasAttributeValueNumber(
                                          attribute,
                                          value.id
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(
                            "\n            " +
                              _vm._s(value.name) +
                              "\n          "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              }),
              0
            )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }